import React from 'react';
import { Button, Modal, Typography } from 'antd';
import { useIntl } from 'react-intl';

const { Text, Title } = Typography;

interface SessionTimeoutModalProps {
  open: boolean;
  secondsRemaining: number;
  onExtend: () => void;
  onLogout: () => void;
  loading?: boolean;
}

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  open,
  secondsRemaining,
  onExtend,
  onLogout,
  loading = false,
}) => {
  const { formatMessage: t } = useIntl();

  return (
    <Modal
      centered
      open={open}
      onCancel={undefined}
      footer={null}
      closable={false}
      maskClosable={false}
      width={400}
      style={{ borderRadius: 16 }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 24,
          textAlign: 'center',
        }}
      >
        <Title
          level={4}
          style={{
            marginBottom: 16,
            textAlign: 'center',
            fontWeight: 700,
            color: '#000',
          }}
        >
          {t({ id: 'screens.timeout.timeout.title', defaultMessage: 'Your session has almost ended' })}
        </Title>

        <Text
          style={{
            color: '#666',
            fontSize: 14,
            marginBottom: 24,
            textAlign: 'center',
            lineHeight: '20px',
          }}
        >
          {t(
            {
              id: 'screens.timeout.timeout.messages.note',
              defaultMessage: 'You still have {seconds} until you are automatically logged out.',
            },
            {
              seconds: `${secondsRemaining} ${t({
                id: 'screens.timeout.timeout.seconds',
                defaultMessage: 'seconds',
              })}`,
            }
          )}
        </Text>

        <Text
          style={{
            color: '#666',
            fontSize: 14,
            marginBottom: 24,
            textAlign: 'center',
            lineHeight: '20px',
          }}
        >
          {t({
            id: 'screens.timeout.timeout.messages.continue',
            defaultMessage: 'Do you want to extend your session?',
          })}
        </Text>

        <div style={{ display: 'flex', gap: 12, width: '100%' }}>
          <Button
            block
            style={{
              background: '#fff',
              color: '#000',
              fontWeight: 500,
              height: 44,
              borderRadius: 8,
              border: '1px solid #000',
            }}
            onClick={onLogout}
            disabled={loading}
          >
            {t({ id: 'buttons.logout', defaultMessage: 'Logout' })}
          </Button>
          <Button
            block
            type="primary"
            loading={loading}
            style={{
              background: '#191919',
              color: '#fff',
              fontWeight: 500,
              height: 44,
              borderRadius: 8,
            }}
            onClick={onExtend}
          >
            {t({ id: 'buttons.extend', defaultMessage: 'Extend' })}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SessionTimeoutModal;

